<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">智慧医疗解决方案</div>
        <div class="title-sub">大数据助力解决地区“就医难”</div>
        <div class="text">
          患者作为医疗服务的需求方， 其就医选择直接影响着整个医疗卫生服务体系的运转和分级诊疗的实现。 橡诺科技帮助政府利用大数据技术和自身丰富的智慧城市建设运营经验，通过对就医选择行为影响因素建立模型，进行系统全面的、并适合地区本身特点的详细分析，可以掌握整个地区医疗卫生服务体系的运转情况，并进行针对性、改善性的干预，同时对干预效果进行预测评估，可以有效切实解决地区各种“就医难”问题。
        </div>
        <div class="title-sub">主要包括如下内容</div>
        <div class="text">
          就医拥挤情况分析和可视化呈现<br>
          地区就医水平分析和可视化呈现<br>
          就医人群流向分析和可视化呈现<br>
          就医舆情和机构口碑综合分析呈现<br>
          地区居民健康水平综合分析呈现<br>
          地区人群就医选择行为分析和预测呈现
          <div class="img"><img src="@/assets/img/solution/11/1.png"></div>
        </div>
        <div class="title-sub">大数据助力地区慢病诊疗</div>
        <div class="text">
          随着中国经济的发展，慢性病已经成为我国居民健康的最大威胁。橡诺科技帮助医院和地区从收集病人信息、评估个体慢病状况、个体化行为干预和治疗，到动态掌握病人健康状况，科研统计等全流程进行整体规划设计和业务流程梳理，并提供全过程信息化支撑服务。<br>
          随着医学模式的变化，慢病管理理念和体系也在发生着变化，橡诺科技站在未来医学发展时代前沿，充分发挥自身大数据技术能力，同时结合病种专业数据分析能力，给医院和地区患者带来具有预防、预测、个体化、参与性和精准化的慢病管理综合解决方案。
          <div class="img"><img src="@/assets/img/solution/11/2.png"></div>
        </div>
        <div class="title-sub">大数据场景定位助力医保控费</div>
        <div class="text">
          随着我国医疗保险制度的不断完善发展， 在解决人民群众“看病贵、看病难”问题发挥了重要的作用，但由于相关法律法规、配套的政策制度措施不完善、 监管机制不健全、宣传教育不到位等，出现了一系列的骗取套取医保基金的违法违规行为，据有机构统计分析，每年大约有3~5%，400~600亿规模的医保缴费属于医疗欺诈。<br>
          橡诺科技在借鉴国外医保资金监管方式的基础上，帮助国内机构走出医保监管“白色迷宫”，建立起电子哨兵式的证据自动采集系统，提高震慑力和监管力度
          <div class="img"><img src="@/assets/img/solution/11/3.png"></div>
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          地区就医水平综合监测、干预预测平台<br>
          完整流程的多病种慢病信息管理平台<br>
          独特方便定制的慢病随访问卷设计<br>
          智能医疗数据分析模型<br>
          自主知识产权的医疗垂直搜索引擎<br>
          医院和区域医疗系统数据集成和交换<br>
          独立的医保监管系统
        </div>
        <div class="title-sub">能力优势</div>
        <div class="text">
          中国智慧城市建设的领先者，同时拥有多年智慧医疗、智慧医院建设和运营经验<br>
丰富的国外医疗行业IT技术服务经验<br>
和国内顶尖医疗机构保持良好合作关系<br>
强大的医疗IT技术设计和实施团队<br>
国内领先的大数据洞察分析能力
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        // width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>